import * as CL from '@design-system/component-library';
import { dsClass } from '../../../../common/constants/dsClasses.js';
import { AddonSubCategory } from '../../../../common/enums.js';
import { BundleAddonGroupRuntimeCharacteristic } from '../../utils/characteristicsFlagsUtilsCoCo.js';
import type { ProductOfferingsResponse } from '../../../../generated/api/productOfferingsResponse.js';
import type { AddonContentSelection, RenderAddonContent } from '../productConfigTypesCoCo.js';

interface MobileAddonContentCoCoProps {
  offer: ProductOfferingsResponse;
  selection: AddonContentSelection;
}

const getCustomApnNames = (offer: ProductOfferingsResponse): string[] | undefined => {
  const dataAddon = offer.bundleAddonProductOffering?.find(
    addon => addon.productOfferingType?.subcategory === AddonSubCategory.MOBILE_DATA_POT
  );
  const apnCharacteristic = dataAddon?.productSpecRuntimeCharacteristics?.find(
    characteristic => characteristic.name === BundleAddonGroupRuntimeCharacteristic.APN_NAME
  );
  if (!apnCharacteristic?.value?.length) {
    return undefined;
  }

  const customValues = apnCharacteristic.value
    .map(value => value.value)
    .filter((value): value is string => !!value && value.toLowerCase() !== 'internet');
  return customValues.length > 0 ? customValues : undefined;
};

export const MobileAddonContentCoCo = ({ offer, selection }: MobileAddonContentCoCoProps) => {
  const customApnNames = getCustomApnNames(offer);
  if (!customApnNames) {
    return null;
  }

  return (
    <div className={`${dsClass.MARGIN_TOP_3} ${dsClass.GRID}`}>
      <div className={`${dsClass.GRID_ROW} ${dsClass.MARGIN_0}`}>
        <div className={`${dsClass.GRID_COL_L_6} ${dsClass.PADDING_0}`}>
          <CL.Dropdown
            items={customApnNames.map(apnName => ({ label: apnName, value: apnName }))}
            label="Corporate APN"
            selectedValue={selection.selectedCharacteristics[BundleAddonGroupRuntimeCharacteristic.APN_NAME]}
            onValueChange={(element: HTMLLIElement) => {
              const value = element.dataset.value;
              if (value) {
                selection.onCharacteristicChange(BundleAddonGroupRuntimeCharacteristic.APN_NAME, value);
              }
            }}
          />
        </div>
      </div>
    </div>
  );
};

export const renderMobileAddonContent: RenderAddonContent = (offer, addonSubcategory, selection) =>
  addonSubcategory === AddonSubCategory.MOBILE_DATA_POT ? (
    <MobileAddonContentCoCo offer={offer} selection={selection} />
  ) : null;
